import { useMemo, useState } from "react";
import { glassStyle } from "../data/utils";
import type { LLCData } from "../types";

type Props = {
  data: LLCData;
  onSelect: (name: string) => void;
};

export function StateSearchBar({ data, onSelect }: Props) {
  const [q, setQ] = useState("");
  const allNames = useMemo(() => Object.keys(data).sort(), [data]);

  const matches = useMemo(() => {
    const trimmed = q.trim().toLowerCase();
    if (!trimmed) return [];
    return allNames
      .filter((n) => n.toLowerCase().includes(trimmed))
      .slice(0, 8);
  }, [q, allNames]);

  return (
    <div className="state-search-bar">
      <div
        style={{
          ...glassStyle,
          display: "flex",
          alignItems: "center",
          gap: 6,
          padding: "6px 10px",
          borderRadius: 999,
        }}
      >
        <SearchIcon />
        <input
          value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder="Search"
          aria-label="Search states"
          style={{
            flex: 1,
            minWidth: 0,
            background: "transparent",
            border: "none",
            outline: "none",
            color: "#fff",
            fontSize: 12,
            padding: "2px 0",
          }}
        />
        {q && (
          <button
            onClick={() => setQ("")}
            aria-label="Clear"
            style={{
              background: "transparent",
              border: "none",
              color: "#fff",
              opacity: 0.6,
              fontSize: 12,
              padding: 0,
            }}
          >
            ✕
          </button>
        )}
      </div>

      {matches.length > 0 && (
        <div
          style={{
            ...glassStyle,
            background: "rgba(10,12,20,0.85)",
            marginTop: 6,
            padding: 4,
            borderRadius: 12,
            width: 200,
            transform: "translateX(-40px)",
            display: "flex",
            flexDirection: "column",
          }}
        >
          {matches.map((name) => (
            <button
              key={name}
              onClick={() => {
                onSelect(name);
                setQ("");
              }}
              style={{
                textAlign: "left",
                background: "transparent",
                border: "none",
                color: "#fff",
                padding: "8px 10px",
                borderRadius: 8,
                fontSize: 13,
              }}
              onMouseEnter={(e) =>
                ((e.currentTarget as HTMLButtonElement).style.background =
                  "rgba(139,92,246,0.22)")
              }
              onMouseLeave={(e) =>
                ((e.currentTarget as HTMLButtonElement).style.background =
                  "transparent")
              }
            >
              {name}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

function SearchIcon() {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
      style={{ flex: "0 0 auto", opacity: 0.85 }}
    >
      <circle cx="11" cy="11" r="7" />
      <line x1="21" y1="21" x2="16.65" y2="16.65" />
    </svg>
  );
}
